import { Details } from './details.js'

export * from './content/index.js'
export * from './details.js'
export * from './summary/index.js'

export default Details
